var THEMES;
(function (THEMES) {
    THEMES["DANGER"] = "danger";
    THEMES["ATTENTION"] = "attention";
    THEMES["SUCCESS"] = "success";
    THEMES["INFO"] = "info";
})(THEMES || (THEMES = {}));
export default THEMES;
//# sourceMappingURL=themes.js.map